<template>
    <div class="inner">
        <div class="slider" style="width: 240px;">
            <slide-picker
                suffix="cm"
                :items="numberList"
                :initial-index="60"
                :tab-index="1"
                @value="onValueHeight"
            />
        </div>
        <div class="slider">
            <slide-picker
                suffix="cm"
                :items="numberList"
                :initial-index="60"
                :tab-index="2"
                @value="onValueHeight"
            />
        </div>
        <div class="slider2">
            <slide-picker
                :items="dayList"
                :tab-index="3"
                @value="onValueDay"
            />
        </div>
        <div class="slider3">
            <slide-picker
                suffix="cm"
                :items="numberList"
                :initial-index="50"
                :tab-index="4"
                @value="onValueDay"
            />
        </div>
        <div class="text-input">
            <label>
                Hello World
                <input
                    type="text"
                />
            </label>
        </div>
    </div>
</template>

<script>
    import SlidePicker from '../components/SlidePicker'

    export default {
        name: 'Playground',
        components: { SlidePicker },
        data () {
            return {
                numberList: Array.range(100, 250),
                dayList: ['하루', '이틀', '삼일', '사일', '오일', '육일', '매일'],
                goodList: Array.range(1, 10),
                selected: 50
            }
        },
        methods: {
            onValueHeight ({ value, index }) {
                console.log(value, index)
            },
            onValueDay ({ value, index }) {
                console.log(value, index)
            }
        }
    }
</script>

<style scoped lang="scss">
    .frame {
        width: 100%;
        height: 100%;
        position: relative;

        label {
            width: 100%;
            height: 100%;
            position: absolute;

            input {
                width: 100%;
                height: 100%;
            }
        }
    }
    .inner {
        padding: 30px;
        overflow-y: hidden;
    }

    .text-input {
        label {
            input {
                width: 100%;
                // max-width: 600px;
                height: 56px;
                border-radius: 4px;
                border: #1e1e1e;
                background-color: #ffffff;
                font-family: NanumSquare, sans-serif;
                font-size: 20px;
                color: #202020;
                text-align: center;
            }

            input:focus {
                outline: none;
            }

            input:focus-visible {
                outline: solid 3px #1e1e1e;
            }
        }
    }

    .slider {
        margin: 10px auto;
        width: 280px;
        height: 66px;
        border-radius: 33.5px;
        box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.1), inset -3px -3px 5px 0 rgba(255, 255, 255, 0.5);
        background-image: radial-gradient(circle at 50% 50%, #ffffff, #ffffff 68%, #eaeaea 107%);
    }

    .slider2 {
        margin: 10px auto;
        width: 200px;
        height: 66px;
    }

    .slider3 {
        margin: 10px auto;
        width: 100%;
        height: 66px;
    }

    .hello {
        width: 100%;
        height: 66px;
    }

    .frame:focus-visible {
        outline: #1e1e1e solid 2px;
    }

</style>
